<template>
  <DefaultHeader>
    <img
      class='lt-logo'
      src="../assets/lbg-logo.svg"
      alt="Lloyds Banking Group Pensions"
    />
    <img
      src='../assets/lifetime-logo.svg'
      class='lt-fyf-logo'
      alt="AHC Lifetime"
      v-show='isOnWelcomePage'
    >
  </DefaultHeader>
</template>


<script>
import DefaultHeader from '../../../src/views/HeaderFyF';

export default {
  components: {
    DefaultHeader,
  },
};
</script>

<style lang='scss'>

.lt-logo {
  height: 110px;
  width: 220px;
}

.lt-fyf-logo {
  z-index: 1;
  height: 60px;
  align-self: flex-start;
  margin-top: 0.875rem;
}

</style>
